import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)

const supportedLanguages = ['ja', 'en', 'es'];
const storedLang = localStorage.getItem('lang');
const savedLang = supportedLanguages.indexOf(storedLang) !== -1
  ? storedLang
  : getBrowserLanguage();

const i18n = new VueI18n({
  globalInjection: true, 
  locale: savedLang,
  fallbackLocale: 'en',
  messages: {
    'ja': require('./assets/languages/ja.json'),
    'en': require('./assets/languages/en.json'),
    'es': require('./assets/languages/es.json')
  }
});

function getBrowserLanguage() {
  const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
  if (browserLang.indexOf('ja') === 0) return 'ja';
  if (browserLang.indexOf('es') === 0) return 'es';
  return 'en';
}

function mountApp() {
  document.documentElement.lang = i18n.locale;
  new Vue({
    store,
    router,
    i18n,
    render: h => h(App),
  }).$mount('#app');
}

async function initializeLanguage() {
  // 旧版本已经保存的语言可能是用户手动选择的，升级后继续尊重它。
  if (supportedLanguages.indexOf(storedLang) !== -1) {
    if (!localStorage.getItem('lang_source')) {
      localStorage.setItem('lang_source', 'legacy');
    }
    mountApp();
    return;
  }

  let detectedLang = getBrowserLanguage();
  let source = 'browser';
  try {
    const result = await http({ method: 'get', url: 'detect_language' });
    if (result && result.code === 200 && result.data &&
        supportedLanguages.indexOf(result.data.lang) !== -1) {
      detectedLang = result.data.lang;
      source = result.data.source || 'ip';
    }
  } catch (e) {
    // 网络或定位服务不可用时使用浏览器语言，不阻止应用启动。
  }

  i18n.locale = detectedLang;
  localStorage.setItem('lang', detectedLang);
  localStorage.setItem('lang_source', source);
  mountApp();
}

initializeLanguage();
